<template>
  <div v-if="project && pages" class="document">
    <SalesReportRoofPrintPage
      :pageNumber="currentPage()"
      :pageCount="salesReportPageCount"
      :project="project"
    />
    <SalesReportHakPrintPage
      :pageNumber="currentPage()"
      :pageCount="salesReportPageCount"
      :project="project"
    />
    <SalesReportZsPrintPage
      :pageNumber="currentPage()"
      :pageCount="salesReportPageCount"
      :project="project"
    />
  </div>
  <div v-else>{{ $t('no_data_found') }}</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SalesReportRoofPrintPage from '@/views/SalesReport/SalesReportRoofPrintPage';
import SalesReportHakPrintPage from '@/views/SalesReport/SalesReportHakPrintPage';
import SalesReportZsPrintPage from '@/views/SalesReport/SalesReportZsPrintPage';

const SALES_REPORT_PRINT_PAGE_COUNT = 3;

export default {
  components: {
    SalesReportRoofPrintPage,
    SalesReportHakPrintPage,
    SalesReportZsPrintPage,
  },
  props: {
    projectNumber: {
      required: true,
      default: null,
    },
  },
  computed: {
    ...mapGetters(['getProjectByNumber']),
    pages() {
      return true;
    },
    salesReportPageCount() {
      return SALES_REPORT_PRINT_PAGE_COUNT;
    },
    project() {
      return this.getProjectByNumber(this.number);
    },
  },
  methods: {
    ...mapActions(['fetchProjectByNumber']),
    currentPage() {
      this.pageCounter += 1;
      return this.pageCounter;
    },
  },
  async mounted() {
    this.number = this.projectNumber;
    await this.fetchProjectByNumber(this.number);
  },
  created() {
    this.pageCounter = 0;
  },
};
</script>

<style src="../Measurement/MeasurementPrintPage.scss" lang="scss" />
